import React, { useEffect, useState } from 'react';

const OutStanding: React.FC = () => {
  const [totalOutstandingCredit, setTotalOutstandingCredit] = useState<number>(0);
  const [displayCount, setDisplayCount] = useState<number>(0);

  useEffect(() => {
    const fetchOutstandingCredit = async () => {
      try {
        const response = await fetch("https://backendcway.causewaycargo.com/superadmin/totaloutstandcount", {
          method: 'GET',
          headers: {
            'auth': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do',
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        const count = result.total_outstanding_credit || 0;
        setTotalOutstandingCredit(Number(count)); // Ensure count is a number
      } catch (error) {
        console.error('Error fetching outstanding credit:', error);
      }
    };

    fetchOutstandingCredit();
  }, []);

  useEffect(() => {
    let start = 0;
    const duration = 7000; // 7 seconds duration for the animation
    const increment = totalOutstandingCredit / (duration / 100);

    const updateCount = () => {
      start += increment;
      if (start >= totalOutstandingCredit) {
        setDisplayCount(totalOutstandingCredit);
      } else {
        setDisplayCount(Math.round(start));
        requestAnimationFrame(updateCount);
      }
    };

    if (totalOutstandingCredit > 0) {
      requestAnimationFrame(updateCount);
    } else {
      setDisplayCount(0); // Reset displayCount if totalOutstandingCredit is 0
    }
  }, [totalOutstandingCredit]);

  return (
    <div className="d-flex flex-column justify-content-between rounded-3 px-8 py-10 mb-8 responsive-dash" style={{ height: '250px' ,backgroundColor: ' #D4DCE1'}}>
      <h1 className='text-dark'>Outstanding Credits</h1>
      <div className="d-flex justify-content-end align-items-end mt-4">
        <h1 className="display-5 text-dark">
        {Number(displayCount).toLocaleString()} QAR
        </h1>
      </div>
    </div>
  );
};

export { OutStanding };
